export enum pageTitle {
    billing = 'Facturation',
    'daily-operation' = 'Gestion au quotidien',
    delivery = 'Livraison',
    'order-tracking' = 'Suivi des Demandes',
    users = 'Paramètres utilisateur',
    profile = 'Profil',
    statistic = 'Statistiques',
    'contact-us' = 'Nous contacter',
    cab = 'Lecture',
    'linge-hebergement' = "Gestion linge d'hébergement",
    'linge-hebergement-param' = "Paramètres linge d'hébergement",
    'dav-param' = 'Paramètres DAV',
    dav = 'DAV',
    bordereaux = 'Bordereaux',
    login = 'Login',
    'mentions-legales' = 'Mentions Légales'
}

export enum subPageTitle {
    export = 'Export',
    lp = 'Linge plat',
    'edit-stock' = 'Edition de stock',
    vt = 'Vêtements de travail',
    porteurs = 'Liste des utilisateurs',
    'add-porteur' = 'Ajouter un utilisateur',
    dotation = 'Dotation',
    edit = 'Edit',
    'add-article' = 'Ajout article',
    mutation = 'Mutation',
    marquage = 'Marquage',
    casier = 'Casier',
    nom = 'Changement de nom',
    fonction = 'Changement de fonction',
    list = 'Liste',
    schedule = 'Liste des Passages',
    sidebar = 'Détails',
    create = 'Création',
    'personal-information' = 'Informations Personnelles',
    'password-change' = 'Changement de mot de passe',
    stock = 'Etat des stocks',
    porteur = 'Rotation des stocks VTs',
    rotation = 'Rotation des stocks de LP',
    '5-last-cleaning' = '5 derniers lavages',
    'cab-db-integrity' = 'Intégrité de la base CAB',
    'conso-history' = 'Historique des consommations',
    'contact-form' = 'Formulaire de contact',
    import = 'Import',
    check = 'Vérification',
    historique = 'Détail des lectures',
    bilan = 'Bilan des lectures',
    confirm = 'Confirmer'
}
